import React from 'react';
import { AppStateContext, AppStateDispatchContext, reducer } from './context/AppContext';
import GateKeeper from './Gatekeeper';
import ModalProvider from './components/ui/modal/ModalProvider';
import { initialAppState } from './context/initialState';
import { LD_CLIENT_ID } from './constants/launchDarkly';

function App() {
  /**
   * React.useMemo helps prevent re-renders if the state is updated but doesn't change.
   */
  function AppWrapper(appState) {
    return React.useMemo(
      () => (
        <ModalProvider key='app'>
          {' '}
          {/* Apricot 4 modals */}
          <AppStateDispatchContext.Provider value={dispatch}>
            <AppStateContext.Provider value={appState}>
              <GateKeeper />
            </AppStateContext.Provider>
          </AppStateDispatchContext.Provider>
        </ModalProvider>
      ),
      [appState]
    );
  }

  // Global App state.
  const [appState, dispatch] = React.useReducer(reducer, initialAppState);

  return [AppWrapper(appState)];
}

if (typeof LD_CLIENT_ID !== 'string' || !LD_CLIENT_ID.trim()) {
  // eslint-disable-next-line no-console
  console.warn(
    'LaunchDarkly is disabled because LD_CLIENT_ID is missing or empty. Set the LaunchDarkly client-side ID to enable feature flags.'
  );
}

export default App;
